// TODO: Move selectors into ~/selectors, currently this is not possible due to the initializaion weaver issue
import { createSelector } from '@reduxjs/toolkit';

import { SliceType } from '~/enums/SliceType';
import { selectClientFolderTree } from '~/redux/api/selectClient';
import { DocumentNavigationSlice } from '~/redux/slices/documentsNavigation';

export const selectDocument = createSelector(
  (root: any) => root[SliceType.DocumentsNavigation],
  (state: DocumentNavigationSlice) => state.currentDocument,
);

export const selectFolderTree = selectClientFolderTree;
